import { FunctionComponent, memo } from "react";

import { IProps } from "./tag-list.types";
import "./tag-list.scss";

/**
 * Display list of tags
 * @param props.tags    Array of tags
 */
const TagList: FunctionComponent<IProps> = ({ tags }) => {
    return (
        <ul className="tag-list">
            {tags.map(({ tag, tagId }) => (
                <li className="tag-list__item" key={tagId}>
                    {tag}
                </li>
            ))}
        </ul>
    );
};

export default memo(TagList);
